/* tslint:disable */
/* eslint-disable */
/**
 * MechanicalKilnAuditService API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';


export const RHIMContractsFileType = {
    PostMortem: 'PostMortem',
    ProcessData: 'ProcessData',
    ProcessMetrixFiltered: 'ProcessMetrixFiltered',
    ProcessMetrixRaw: 'ProcessMetrixRaw',
    ProcessMetrixVertex: 'ProcessMetrixVertex',
    ProcessMetrixSummary: 'ProcessMetrixSummary',
    ProcessMetrixZip: 'ProcessMetrixZip',
    Stl: 'STL',
    HarmonizedSummary: 'HarmonizedSummary',
    ProcessDataSplit: 'ProcessDataSplit',
    Pts: 'PTS',
    Clinker: 'Clinker',
    KilnFeed: 'KilnFeed',
    HotMeal: 'HotMeal',
    Lignite: 'Lignite',
    StopLogs: 'StopLogs',
    IrScan: 'IRScan',
    KilnShellCooling: 'KilnShellCooling',
    KilnProcessData: 'KilnProcessData',
    FerrotronSummary: 'FerrotronSummary',
} as const;

export type RHIMContractsFileType = typeof RHIMContractsFileType[keyof typeof RHIMContractsFileType];



export const RHIMContractsVesselType = {
    Bof: 'BOF',
    Rh: 'RH',
    Eaf: 'EAF',
    Ladle: 'Ladle',
    Crk: 'CRK',
    Rhl: 'RHL',
    Aod: 'AOD',
    Bfr: 'BFR',
    Srf: 'SRF',
    Cou: 'COU',
    Hml: 'HML',
} as const;

export type RHIMContractsVesselType = typeof RHIMContractsVesselType[keyof typeof RHIMContractsVesselType];



export const RHIMMechanicalKilnAuditServiceDataMechanicalKilnAuditState = {
    InProgress: 'InProgress',
    Failed: 'Failed',
    Ready: 'Ready',
} as const;

export type RHIMMechanicalKilnAuditServiceDataMechanicalKilnAuditState = typeof RHIMMechanicalKilnAuditServiceDataMechanicalKilnAuditState[keyof typeof RHIMMechanicalKilnAuditServiceDataMechanicalKilnAuditState];


export interface RHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditDto {
    'id': string;
    'vesselId': string;
    'comment'?: string | null;
    'emailOfResponsible'?: string | null;
    'originalFilename': string;
    'uploadDate': string;
    'mechanicalKilnAuditState': RHIMMechanicalKilnAuditServiceDataMechanicalKilnAuditState;
    'errorMessage'?: string | null;
    'ovalityMeasurement'?: RHIMMechanicalKilnAuditServiceV1ModelsOvalityMeasurementDto | null;
    'rollerShaftBendingMeasurement'?: RHIMMechanicalKilnAuditServiceV1ModelsRollerShaftBendingMeasurementDto | null;
    'shellRunoutMeasurement'?: RHIMMechanicalKilnAuditServiceV1ModelsShellRunoutMeasurementDto | null;
    'tireWobblingMeasurement'?: RHIMMechanicalKilnAuditServiceV1ModelsTireWobblingMeasurementDto | null;
}


export interface RHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditUpdateDto {
    'vesselId': string;
    'comment'?: string | null;
    'emailOfResponsible'?: string | null;
}
export interface RHIMMechanicalKilnAuditServiceV1ModelsOvalityMeasurementDto {
    'measurementDate': string;
}
export interface RHIMMechanicalKilnAuditServiceV1ModelsRollerShaftBendingMeasurementDto {
    'measurementDate': string;
}
export interface RHIMMechanicalKilnAuditServiceV1ModelsShellRunoutMeasurementDto {
    'measurementDate': string;
}
export interface RHIMMechanicalKilnAuditServiceV1ModelsTireWobblingMeasurementDto {
    'measurementDate': string;
}

/**
 * MechanicalKilnAuditApi - axios parameter creator
 */
export const MechanicalKilnAuditApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes the Mechanical Kiln Audit with the specified id.
         * @summary Deletes the Mechanical Kiln Audit with the specified id.
         * @param {string} mechanicalKilnAuditId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMechanicalkilnauditsMechanicalkilnauditid: async (mechanicalKilnAuditId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mechanicalKilnAuditId' is not null or undefined
            assertParamExists('deleteMechanicalkilnauditsMechanicalkilnauditid', 'mechanicalKilnAuditId', mechanicalKilnAuditId)
            const localVarPath = `/mechanicalkilnaudits/{mechanicalKilnAuditId}`
                .replace('{mechanicalKilnAuditId}', encodeURIComponent(String(mechanicalKilnAuditId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the  Mechanical Kiln Audit with the specified id.
         * @summary Returns the  Mechanical Kiln Audit with the specified id.
         * @param {string} mechanicalKilnAuditId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMechanicalkilnauditsMechanicalkilnauditid: async (mechanicalKilnAuditId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mechanicalKilnAuditId' is not null or undefined
            assertParamExists('getMechanicalkilnauditsMechanicalkilnauditid', 'mechanicalKilnAuditId', mechanicalKilnAuditId)
            const localVarPath = `/mechanicalkilnaudits/{mechanicalKilnAuditId}`
                .replace('{mechanicalKilnAuditId}', encodeURIComponent(String(mechanicalKilnAuditId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of the Mechanical Kiln Audits for the specified vessel.
         * @summary Returns a list of the Mechanical Kiln Audits for the specified vessel.
         * @param {string} vesselId Format - uuid. The id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidMechanicalkilnaudits: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidMechanicalkilnaudits', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/mechanicalkilnaudits`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the Mechanical Kiln Audit with the specified id.
         * @summary Updates the Mechanical Kiln Audit with the specified id.
         * @param {string} mechanicalKilnAuditId Format - uuid.
         * @param {RHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditUpdateDto} [rHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMechanicalkilnauditsMechanicalkilnauditid: async (mechanicalKilnAuditId: string, rHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditUpdateDto?: RHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mechanicalKilnAuditId' is not null or undefined
            assertParamExists('putMechanicalkilnauditsMechanicalkilnauditid', 'mechanicalKilnAuditId', mechanicalKilnAuditId)
            const localVarPath = `/mechanicalkilnaudits/{mechanicalKilnAuditId}`
                .replace('{mechanicalKilnAuditId}', encodeURIComponent(String(mechanicalKilnAuditId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MechanicalKilnAuditApi - functional programming interface
 */
export const MechanicalKilnAuditApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MechanicalKilnAuditApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes the Mechanical Kiln Audit with the specified id.
         * @summary Deletes the Mechanical Kiln Audit with the specified id.
         * @param {string} mechanicalKilnAuditId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMechanicalkilnauditsMechanicalkilnauditid(mechanicalKilnAuditId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMechanicalkilnauditsMechanicalkilnauditid(mechanicalKilnAuditId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MechanicalKilnAuditApi.deleteMechanicalkilnauditsMechanicalkilnauditid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the  Mechanical Kiln Audit with the specified id.
         * @summary Returns the  Mechanical Kiln Audit with the specified id.
         * @param {string} mechanicalKilnAuditId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMechanicalkilnauditsMechanicalkilnauditid(mechanicalKilnAuditId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMechanicalkilnauditsMechanicalkilnauditid(mechanicalKilnAuditId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MechanicalKilnAuditApi.getMechanicalkilnauditsMechanicalkilnauditid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a list of the Mechanical Kiln Audits for the specified vessel.
         * @summary Returns a list of the Mechanical Kiln Audits for the specified vessel.
         * @param {string} vesselId Format - uuid. The id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidMechanicalkilnaudits(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidMechanicalkilnaudits(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MechanicalKilnAuditApi.getVesselsVesselidMechanicalkilnaudits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the Mechanical Kiln Audit with the specified id.
         * @summary Updates the Mechanical Kiln Audit with the specified id.
         * @param {string} mechanicalKilnAuditId Format - uuid.
         * @param {RHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditUpdateDto} [rHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putMechanicalkilnauditsMechanicalkilnauditid(mechanicalKilnAuditId: string, rHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditUpdateDto?: RHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putMechanicalkilnauditsMechanicalkilnauditid(mechanicalKilnAuditId, rHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MechanicalKilnAuditApi.putMechanicalkilnauditsMechanicalkilnauditid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MechanicalKilnAuditApi - factory interface
 */
export const MechanicalKilnAuditApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MechanicalKilnAuditApiFp(configuration)
    return {
        /**
         * Deletes the Mechanical Kiln Audit with the specified id.
         * @summary Deletes the Mechanical Kiln Audit with the specified id.
         * @param {string} mechanicalKilnAuditId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMechanicalkilnauditsMechanicalkilnauditid(mechanicalKilnAuditId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMechanicalkilnauditsMechanicalkilnauditid(mechanicalKilnAuditId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the  Mechanical Kiln Audit with the specified id.
         * @summary Returns the  Mechanical Kiln Audit with the specified id.
         * @param {string} mechanicalKilnAuditId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMechanicalkilnauditsMechanicalkilnauditid(mechanicalKilnAuditId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditDto> {
            return localVarFp.getMechanicalkilnauditsMechanicalkilnauditid(mechanicalKilnAuditId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of the Mechanical Kiln Audits for the specified vessel.
         * @summary Returns a list of the Mechanical Kiln Audits for the specified vessel.
         * @param {string} vesselId Format - uuid. The id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidMechanicalkilnaudits(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditDto>> {
            return localVarFp.getVesselsVesselidMechanicalkilnaudits(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the Mechanical Kiln Audit with the specified id.
         * @summary Updates the Mechanical Kiln Audit with the specified id.
         * @param {string} mechanicalKilnAuditId Format - uuid.
         * @param {RHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditUpdateDto} [rHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMechanicalkilnauditsMechanicalkilnauditid(mechanicalKilnAuditId: string, rHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditUpdateDto?: RHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditUpdateDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putMechanicalkilnauditsMechanicalkilnauditid(mechanicalKilnAuditId, rHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MechanicalKilnAuditApi - object-oriented interface
 */
export class MechanicalKilnAuditApi extends BaseAPI {
    /**
     * Deletes the Mechanical Kiln Audit with the specified id.
     * @summary Deletes the Mechanical Kiln Audit with the specified id.
     * @param {string} mechanicalKilnAuditId Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteMechanicalkilnauditsMechanicalkilnauditid(mechanicalKilnAuditId: string, options?: RawAxiosRequestConfig) {
        return MechanicalKilnAuditApiFp(this.configuration).deleteMechanicalkilnauditsMechanicalkilnauditid(mechanicalKilnAuditId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the  Mechanical Kiln Audit with the specified id.
     * @summary Returns the  Mechanical Kiln Audit with the specified id.
     * @param {string} mechanicalKilnAuditId Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMechanicalkilnauditsMechanicalkilnauditid(mechanicalKilnAuditId: string, options?: RawAxiosRequestConfig) {
        return MechanicalKilnAuditApiFp(this.configuration).getMechanicalkilnauditsMechanicalkilnauditid(mechanicalKilnAuditId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of the Mechanical Kiln Audits for the specified vessel.
     * @summary Returns a list of the Mechanical Kiln Audits for the specified vessel.
     * @param {string} vesselId Format - uuid. The id of the vessel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidMechanicalkilnaudits(vesselId: string, options?: RawAxiosRequestConfig) {
        return MechanicalKilnAuditApiFp(this.configuration).getVesselsVesselidMechanicalkilnaudits(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the Mechanical Kiln Audit with the specified id.
     * @summary Updates the Mechanical Kiln Audit with the specified id.
     * @param {string} mechanicalKilnAuditId Format - uuid.
     * @param {RHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditUpdateDto} [rHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putMechanicalkilnauditsMechanicalkilnauditid(mechanicalKilnAuditId: string, rHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditUpdateDto?: RHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditUpdateDto, options?: RawAxiosRequestConfig) {
        return MechanicalKilnAuditApiFp(this.configuration).putMechanicalkilnauditsMechanicalkilnauditid(mechanicalKilnAuditId, rHIMMechanicalKilnAuditServiceV1ModelsMechanicalKilnAuditUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MechanicalKilnAuditDownloadApi - axios parameter creator
 */
export const MechanicalKilnAuditDownloadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Download the xml file of the Mechanical Kiln Audit
         * @summary Download the xml file of the Mechanical Kiln Audit
         * @param {string} mechanicalKilnAuditId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMechanicalkilnauditsMechanicalkilnauditidDownloadXml: async (mechanicalKilnAuditId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mechanicalKilnAuditId' is not null or undefined
            assertParamExists('getMechanicalkilnauditsMechanicalkilnauditidDownloadXml', 'mechanicalKilnAuditId', mechanicalKilnAuditId)
            const localVarPath = `/mechanicalkilnaudits/{mechanicalKilnAuditId}/download/xml`
                .replace('{mechanicalKilnAuditId}', encodeURIComponent(String(mechanicalKilnAuditId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MechanicalKilnAuditDownloadApi - functional programming interface
 */
export const MechanicalKilnAuditDownloadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MechanicalKilnAuditDownloadApiAxiosParamCreator(configuration)
    return {
        /**
         * Download the xml file of the Mechanical Kiln Audit
         * @summary Download the xml file of the Mechanical Kiln Audit
         * @param {string} mechanicalKilnAuditId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMechanicalkilnauditsMechanicalkilnauditidDownloadXml(mechanicalKilnAuditId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMechanicalkilnauditsMechanicalkilnauditidDownloadXml(mechanicalKilnAuditId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MechanicalKilnAuditDownloadApi.getMechanicalkilnauditsMechanicalkilnauditidDownloadXml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MechanicalKilnAuditDownloadApi - factory interface
 */
export const MechanicalKilnAuditDownloadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MechanicalKilnAuditDownloadApiFp(configuration)
    return {
        /**
         * Download the xml file of the Mechanical Kiln Audit
         * @summary Download the xml file of the Mechanical Kiln Audit
         * @param {string} mechanicalKilnAuditId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMechanicalkilnauditsMechanicalkilnauditidDownloadXml(mechanicalKilnAuditId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getMechanicalkilnauditsMechanicalkilnauditidDownloadXml(mechanicalKilnAuditId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MechanicalKilnAuditDownloadApi - object-oriented interface
 */
export class MechanicalKilnAuditDownloadApi extends BaseAPI {
    /**
     * Download the xml file of the Mechanical Kiln Audit
     * @summary Download the xml file of the Mechanical Kiln Audit
     * @param {string} mechanicalKilnAuditId Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMechanicalkilnauditsMechanicalkilnauditidDownloadXml(mechanicalKilnAuditId: string, options?: RawAxiosRequestConfig) {
        return MechanicalKilnAuditDownloadApiFp(this.configuration).getMechanicalkilnauditsMechanicalkilnauditidDownloadXml(mechanicalKilnAuditId, options).then((request) => request(this.axios, this.basePath));
    }
}



